import { render, staticRenderFns } from "./ConversionForm.vue?vue&type=template&id=2ba67ffd&"
import script from "./ConversionForm.vue?vue&type=script&lang=js&"
export * from "./ConversionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports